import { type Nil, isNilOrEmptyString } from "@mcwd/typescript-type-guards";
import type { LanguageCountryLocale } from "../../../types-and-definitions/locale-defs/Locales.js";
import { getSiteLangFromOtGeoQuerystring } from "./getSiteLangFromOtGeoQuerystring.js";
import { getSiteLangFromBrowserLanguage } from "./getSiteLangFromBrowserLanguage.js";
import { getSiteLangFromGeoLocation } from "./getSiteLangFromGeoLocation.js";
import { getSiteLangFromGeoLocationExtendedRegion } from "./getSiteLangFromGeoLocationExtendedRegion.js";

export function getInferredSiteLang (): LanguageCountryLocale | Nil
{
  const otGeoQueryResult = getSiteLangFromOtGeoQuerystring();
  if (!isNilOrEmptyString(otGeoQueryResult)){
    return otGeoQueryResult;
  }
  const geoLocResult = getSiteLangFromGeoLocation();
  if (!isNilOrEmptyString(geoLocResult)){
    return geoLocResult;
  }
  const browserLangResult = getSiteLangFromBrowserLanguage();
  if (!isNilOrEmptyString(browserLangResult)){
    return browserLangResult;
  }
  const geoLocFromExtendedRegion =  getSiteLangFromGeoLocationExtendedRegion();
  if (!isNilOrEmptyString(geoLocFromExtendedRegion)){
    return geoLocFromExtendedRegion;
  }
  return null;
  
  // return applyDefaultIfNilOrWhiteSpace(
  //   null,
  //   getSiteLangFromOtGeoQuerystring,
  //   getSiteLangFromGeoLocation,
  //   getSiteLangFromBrowserLanguage,
  //   getSiteLangFromGeoLocationExtendedRegion,
  //   { defaultValue: null }
  // );
}
